/// <summary name='cafm.docs'>Container object for CAFM Documents code</summary>
cafm.docs = {
    get listSelector() { return '#' + cafm.res.consts.ElementId_DocumentList; },
    attachmentsSelector: '#attachLv',
    settings: null,
    documentFiltersElement: null,
    init: function (settings) {
        /// <summary>Initialises the documents code</summary>

        this.settings = settings;

        // set doc list view request data if there is request data
        if (this.settings.RequestData) {

            var getDocsReqData = {};
            cafm.docs.funcs.applyRequestData(getDocsReqData);
            $('{0} .cLv'.format(cafm.docs.listSelector)).setCriteria(getDocsReqData);
        }
    },
    listPanelSelect: function (e) {
        /// <summary>Handles when a document panel is selected</summary>
        /// <param name="e" type="Object">Object containing the panel item selected</param>

        var item = $(e.item);
        var plc = $('[data-action]', item);

        if (!plc.data('contentLoaded')) {

            plc.loadView({
                url: '{0}/{1}'.format(cafm.url.get(plc.data('action')), cafm.docs.settings.ParentEntityId)
            }).data('contentLoaded', true);
        }
    },
    refreshAttachments: function() {      

        cafm.util.refreshList({
            listSelector: cafm.docs.attachmentsSelector
        });
    },
    refreshList: function (o) {
        /// <summary>Shows the document list</summary>
        /// <param name="o" type="Object">Show list options object, can include a message parameter named msg</param>

        if (o && o.expandDocsPanel) {
            var pb = $("#docsPanelBar");
            var panelBar = pb.data("kendoPanelBar");
            $('.k-header.k-state-selected', pb).removeClass('k-state-selected');
            var docsItem = $('li[data-key="documents"]', pb);
            panelBar.expand(docsItem);
            $('> .k-header', docsItem).addClass('k-state-selected');
        }

        cafm.util.refreshList({
            listSelector: cafm.docs.listSelector,
            key: cafm.res.consts.DataKey_Documents
        });

        if (o && o.msg) {

            $('#viewDocs').showMessage({ Type: cafm.enums.MessageType.Success, Title: o.msg });
        }
    },
    editToolbar: {
        update: function (e) {

            var docViewModel = $('#actionFormPlc').getViewModel();
            cafm.docs.funcs.applyRequestData(docViewModel);

            cafm.actions.execute({
                url: cafm.docs.settings.DataConfig.UpdatePath,
                values: docViewModel,
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                statusCodeFuncs: {
                    200: function (r) {
                        cafm.docs.refreshList({
                            msg: cafm.res.str.MessageDocumentUpdated
                        });
                        cafm.views.closeActionWindow();
                    }
                }
            });
        },
        cancel: function (e) {
            /// <summary>Handler for when cancelling out of doc creation or edits</summary>
            /// <param name="e" type="Object">DOM event</param>

            cafm.views.closeActionWindow();
        }
    },
    /// <field name='listToolbar' type='Object'>Document list toolbar</field>
    listToolbar: {
        edit: function (e) {
            /// <summary>Edit handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var editBtn = $(e.target);
            var editTarget = editBtn.data('editTarget');
            var lv = editBtn.getLvFromTb();
            var id = editTarget.data('id');

            if (!id) {

                $('#viewDocs').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoDocumentSelected });
                return;
            }
            else {

                $('#viewDocs').hideMessage();
            }

            var doc = lv.element.getListViewDataItem(id, 'DocumentData.ID');
            var vm = doc.DocumentData.toJSON();
            vm.DocumentId = vm.ID;
            vm.ParentID = cafm.docs.settings.ParentEntityId;
            vm.AppendToWorkOrder = doc.AppendToWorkOrder;
            vm.submit = cafm.docs.editToolbar.update;
            vm.cancel = cafm.docs.editToolbar.cancel;

            cafm.views.openActionWindow({
                url: cafm.url.get('Documents/EditDocument/{0}'.format(id)),
                isForm: true,
                viewModel: vm,
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleEditDocument,
                    height: 280
                }
            });
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            // get the ids
            var selIds = $(e.target).getListSelectedParentChildArray({ parentId: cafm.docs.settings.ParentEntityId, field: 'DocumentData.ID' });
            if (!selIds) {
                $('#viewDocs').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoDocumentSelected });
                return;
            }

            // apply the request data
            selIds.forEach(function (idsItem) {

                cafm.docs.funcs.applyRequestData(idsItem);
            });
            
            // delete the documents
            cafm.actions.execute({
                url: cafm.docs.settings.DataConfig.DeletePath,
                values: selIds,
                elementId: 'viewDocs',
                loaderTarget: '#docsPanelBar',
                statusCodeFuncs: {
                    200: function (r) {

                        // refresh the doc list
                        cafm.docs.refreshList();

                        // show removed message
                        $('#viewDocs').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });

                        // call handler
                        cafm.util.callFunction(cafm.docs.settings.DataConfig.OnClientDelete);
                    }
                }
            });
        },
        add: function (e) {

            $('#viewDocs').hideMessage();

            cafm.views.openActionWindow({
                url: cafm.url.get('Documents/AddExisting'),
                isForm: true,
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleAddExisting,
                    width: cafm.views.actionWindowConfig.large.width(),
                    height: cafm.views.actionWindowConfig.large.height()
                }
            });
        },
        upload: function (e) {

            $('#viewDocs').hideMessage();

            cafm.views.openActionWindow({
                url: cafm.url.get('Documents/UploadNew'),
                isForm: true,
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleUploadNew,
                    width: cafm.views.actionWindowConfig.large.width(),
                    height: cafm.views.actionWindowConfig.large.height()
                }
            });
        }
    },
    /// <field name='uploadNewToolbar' type='Object'>Upload new documents toolbar</field>
    uploadNewToolbar: {

        upload: function (e) {
            /// <summary>Submit the uploaded documents for creation</summary>
            /// <param name="e" type="Object">DOM Event</param>

            var docsPlc = $('#uploadNewDocsPlc').hideMessage(), docs = [], invalidCount = 0;

            // loop each document form
            $('#uploadNewDocsPlc .docForm').each(function (i, el) {

                var docForm = $(el);
                var doc = docForm.data('viewModel').toJSON();

                // clear any previous validation as documents 2+ can be empty
                docForm.clearValidateElements();

                // if doc 2+ and empty then treat as valid
                if (i > 0 && cafm.docs.isDocEmpty(doc)) {

                    return true;
                }

                // check file upload is there
                var fu = cafm.fu.getFileUpload(doc.UploadID), hasUpload = fu && fu.filename;

                // validate document and check upload
                if (docForm.validateElement() && hasUpload) {

                    // it's ok push the document and set its filename
                    doc.Filename = fu.filename;
                    docs.push(doc);
                }
                else {

                    if (!hasUpload) {

                        // if not find the upload field and add the validation message
                        // this is required as standard validation won't work within the iframe
                        docForm.find('.fuCont').addUploadFieldValidationMessage({
                            elementId: 'docUploadValMsg' + i
                        });
                    }

                    invalidCount++;
                }
            });

            // if there are validation messages then show them
            if (invalidCount) {

                docsPlc.showMessage({ type: cafm.enums.MessageType.Error, title: cafm.res.str.MessageInvalidInput });
            }
            // otherwise create the uploaded documents
            else {

                // go through each document
                docs.forEach(function (docItem) {

                    // assign folder ID
                    docItem.FolderID = cafm.docs.funcs.getUploadDocumentFolder();

                    // apply any poaren t entity specific request data
                    cafm.docs.funcs.applyRequestData(docItem);
                });

                // create the uploaded documents
                cafm.actions.execute({
                    url: cafm.docs.settings.DataConfig.CreatePath,
                    values: docs,
                    elementId: 'uploadNewDocsPlc',
                    loaderTarget: '#actionPanel,#docUploadTb .btn[data-key="Upload"]',
                    preventValidate: true,
                    statusCodeFuncs: {
                        200: function (r) {

                            // refresh the doc list
                            cafm.docs.refreshList({
                                expandDocsPanel: true,
                                msg: cafm.res.str.MessageDocumentAdded
                            });

                            // call handler
                            cafm.util.callFunction(cafm.docs.settings.DataConfig.OnClientCreate);

                            // close the action window
                            cafm.views.closeActionWindow();
                        }
                    }
                });
            }
        },
        back: function (e) {
            /// <summary>Cancels out of the upload documents form</summary>
            /// <param name="e" type="Object">DOM Event</param>

            // hide the upload form
            $('#uploadNewDocsPlc').hide();

            // hide the doc upload form toolbar
            $('#docUploadTb').hideImp();

            // show the doc folder selection element
            $('#selectDocFolderPlc').show();

            // show the doc folder selection toolbar
            $('#docTreeTb').showImp();
        }
    },
    /// <field name='searchToolbar' type='Object'>Search documents toolbar</field>
    searchToolbar: {
        search: function (e) {
            /// <summary>Execute the document search</summary>
            /// <param name="e" type="Object">DOM Event</param>

            $('#docSearchPlc #documentsWrapper').show();
            $('#docSearchPlc').hideMessage();
            $('#docSearchLv .cLv').setCriteria(cafm.docs.documentFiltersElement.getViewModel()) // set criteria
                .refreshListDS({ resetPage: true }); // refresh the datasource
        },
        reset: function (e) {
            /// <summary>Reset the document search</summary>
            /// <param name="e" type="Object">DOM Event</param>

            cafm.docs.documentFiltersElement.bindViewModel({
                viewModel: cafm.docs.documentFiltersElement.data('DefaultViewModel')
            }).refreshForm();
            cafm.docs.searchToolbar.search();
        },
        add: function (e) {
            /// <summary>Add the selected documents</summary>
            /// <param name="e" type="Object">DOM Event</param>

            var docIds = $('#docSearchLv').getListSelectedParentChildArray({ parentId: cafm.docs.settings.ParentEntityId, field: 'ID' });
            
            cafm.docs.funcs.addExistingDocuments({
                container: $('#docSearchPlc'),
                ids: docIds
            });
        },
        cancel: function (e) {

            cafm.views.closeActionWindow();
        }
    },
    isDocEmpty: function (doc) {
        /// <summary>Determines if a document object has user input</summary>
        /// <param name="doc" type="Object">The document object</param>
        /// <returns type="Boolean">True if the document has no input</returns>

        var fu = doc.UploadID ? cafm.fu.getFileUpload(doc.UploadID) : null;
        var d = doc.Description;
        var r = doc.Reference;
        var dt = doc.DocumentTypeId && doc.DocumentTypeId != cafm.guid.empty;
        var uf = fu && cafm.util.hasStringVal(fu.filename);

        return !d && !r && !dt && !uf;
    },
    funcs: {

        addExistingDocuments: function (args) {
            /// <summary>Add existing documents helper, sends document add existing data to the server</summary>
            /// <param name="args" type="Object">The add existing args object containing list of document IDs and the action container element</param>

            var docIds = args.ids, container = args.container;

            if (!cafm.util.hasItem(docIds)) {
                container.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoDocumentSelected });
                return;
            }

            // convert to pids if not already done so
            if (isStr(docIds[0])) {

                var pids = [];
                docIds.forEach(function (id) {
                    if (cafm.util.guidHasValue(id)) {
                        pids.push(cafm.util.createParentChildId(cafm.docs.settings.ParentEntityId, id));
                    }
                });
            }
            else {

                pids = docIds;
            }

            // check the document isn't already attached
            var currentDocIds = $(cafm.docs.listSelector).getListVals({ field: 'DocumentData.ID' }); // extract the Id field of the existing docs
            pids = cafm.util.where(pids, function (pid) {
                return currentDocIds.indexOf(pid.ChildID.ID) < 0;
            });

            if (pids.length > 0) {

                pids.forEach(function (idsItem) {

                    cafm.docs.funcs.applyRequestData(idsItem);
                });

                cafm.actions.execute({
                    url: cafm.docs.settings.DataConfig.AttachPath,
                    values: pids,
                    element: container[0],
                    loaderTarget: '#actionPanel,#docTreeTb [data-key="Add"],#docSearchTb [data-key="Add"]',
                    statusCodeFuncs: {
                        200: function (r) {

                            // refresh the doc list
                            cafm.docs.refreshList({
                                expandDocsPanel: true,
                                msg: cafm.res.str.MessageDocumentAdded
                            });

                            // call handler
                            cafm.util.callFunction(cafm.docs.settings.DataConfig.OnClientAttach);

                            // close action window
                            cafm.views.closeActionWindow();
                        }
                    }
                });
            }
            else {

                container.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageDocumentsAlreadyLinked });
            }
        },
        applyRequestData: function (dto) {
            /// <summary>Apply request data to document web  api dto</summary>
            /// <param name="dto" type="Object">The web api DTO</param>

            var s = cafm.docs.settings;
            if (s.RequestData && isStr(s.RequestDataName)) {

                dto[s.RequestDataName] = s.RequestData;
            }
        },
        prepareUploadNewForm: function (defaultDocumentType) {
            /// <summary>Prepares the document uploads form</summary>
            /// <param name="defaultDocumentType" type="Object">The default document type</param>

            var parentId = cafm.docs.settings.ParentEntityId;
            var appendToWo;
            switch (cafm.getCurrentModule()) {
                case cafm.enums.CAFMModuleEnum.Helpdesk:
                    appendToWo = true;
                    break;
                default:
                    appendToWo = false;
                    break;
            }

            // determine the default document type ID and description
            var defDocId, defDocDes;
            if (defaultDocumentType) {

                defDocId = defaultDocumentType.value;
                defDocDes = defaultDocumentType.text;
            }

            $('#uploadNewDocsPlc .docForm').each(function (i, el) {
                var df = $(el);
                df.bindViewModel({
                    viewModel: {
                        ParentId: parentId,
                        AppendToWorkOrder: appendToWo,
                        DocumentTypeID: defDocId,
                        DocumentTypeDescription: defDocDes
                    }
                });
            });
            $('#uploadNewDocsPlc .addUpload').click(this.showNextUpload);
        },
        prepareDocumentSearch: function (defaultCriteria) {
            /// <summary>Prepares the document uploads form</summary>

            // button bindings
            var addExistingButtons = {
                search: cafm.docs.searchToolbar.search,
                reset: cafm.docs.searchToolbar.reset,
                add: cafm.docs.searchToolbar.add,
                cancel: cafm.docs.searchToolbar.cancel
            }

            // merge tghe criteria with button bindings
            $.extend(defaultCriteria, addExistingButtons);

            // get filters element
            var searchFilters = $('#' + cafm.res.consts.ElementId_DocumentSearchFilters);
            // keep a copy of default criteria for reset function
            searchFilters.data('DefaultViewModel', cafm.util.clone(defaultCriteria, true));
            // bind the default filter view model
            searchFilters.bindViewModel({
                viewModel: defaultCriteria
            });
            // assign filter elements for later access
            cafm.docs.documentFiltersElement = searchFilters;

            searchFilters.find('.cfControl').enterPressed(function () {

                searchFilters.parents('.actionWindow:first').find('[data-key="Search"]').click();
            });
        },
        getUploadDocumentFolder: function () {
            /// <summary>Gets the document folder ID for the upload form</summary>
            /// <returns type="String">Document folder ID that is set on the upload form element</returns>

            return $('#uploadNewDocsPlc').data('folderid');
        },
        setUploadDocumentFolder: function (folderId) {
            /// <summary>Sets the document folder ID for the upload form</summary>

            $('#uploadNewDocsPlc').data('folderid', folderId);
        },
        showNextUpload: function (e) {
            /// <summary>Adds another document upload form</summary>
            /// <param name="e" type="Object">DOM Event</param>

            var me = $(this);
            var i = me.parents('.docForm').attr('data-index');
            i++;
            var docCnt = $('.docForm[data-index="{0}"]'.format(i));
            var fu = cafm.fu.getFileUploadByContainer($('.fuCont', docCnt));
            fu.initFrame(fu);
            docCnt.slideDown();
            me.hide();
        }
    },
    handlers: {
        /// <summary>Document handler functions and objects</summary>

        addExistingTabChanged: function (args) {
            /// <summary>Add existing tab changed handler</summary>
            /// <param name="args" type="Object">Tab changed args object</param>
            
            cafm.forms.handlers.formTabChanged(args, function () {

                var key = $(args.item).data('key'),
                    searchTb = $('#docSearchTb'),
                    treeTb = $('#docTreeTb');

                switch (key) {

                    case cafm.res.consts.DataKey_DocumentSearch:

                        // hide doc tree toolbar
                        treeTb.hideImp();

                        if (!searchTb.data('setup')) {

                            cafm.util.positionWindowButtons({
                                container: searchTb
                            });
                            searchTb.setupToolbar().data('setup', true);
                        }
                        else {

                            searchTb.showImp();
                        }

                        break;

                    case cafm.res.consts.DataKey_DocumentTree:
                        
                        // hide doc search toolbar
                        searchTb.hideImp();

                        if (!treeTb.data('setup')) {

                            cafm.util.positionWindowButtons({
                                container: treeTb
                            });
                            treeTb.setupToolbar().data('setup', true);
                        }
                        else {

                            treeTb.showImp();
                        }

                        break;
                }
            });
        },
        docTreeSelected: function (args) {
            /// <summary>Document tree item selected handler</summary>
            /// <param name="args" type="Object">Tree item selected args object</param>

            // tree view item selected class
            var tvs = cafm.res.consts.CssClass_TreeViewSelected;

            switch (args.mode) {

                // if mode is document folder selection then check item type is a document folder and toggle selection class
                case cafm.enums.TreeViewMode.DocumentFolderSelection:
                    
                    if (args.type == cafm.enums.TreeViewItemType.DocumentFolder) {
                        args.tree.element.find('.{0}'.format(tvs, args.item.data('key'))).removeClass(tvs);
                        args.item.toggleClass(tvs);
                    }
                    break;

                // if mode is document selection then check item type is a document and toggle selection class
                case cafm.enums.TreeViewMode.DocumentSelection:

                    if (args.type == cafm.enums.TreeViewItemType.Document) args.item.toggleClass(tvs);
                    break;
            }
        },
        docTreeToolbar: {
            /// <summary>Document tree toolbar handler object</summary>

            add: function () {
                /// <summary>Document tree toolbar add button handler, used to add documents</summary>

                var docIds = [];
                $('#docTree').find('.' + cafm.res.consts.CssClass_TreeViewSelected).each(function (i, nodeEl) {

                    docIds.push($(nodeEl).data('key'));
                });
                
                cafm.docs.funcs.addExistingDocuments({
                    container: $('#docTreePlc'),
                    ids: docIds
                });
            },
            cancel: function () {
                /// <summary>Document tree toolbar cancel button handler</summary>

                cafm.toolbar.standardActionToolbar.cancel();
            }
        },
        search: {
            preDataSourceRead: r => {
                // set exlude IDs header on request
                cafm.web.funcs.setRequestExcludeIds({
                    dataSource: $(cafm.docs.listSelector).getLv().dataSource,
                    idField: 'DocumentData.ID',
                    request: r
                });
            }
        },
        docFolderTreeToolbar: {
            /// <summary>Document folder tree toolbar handler object</summary>

            select: function () {
                /// <summary>Document folder tree toolbar select button handler, sets the folder ID on the upload form</summary>

                // get the folder ID
                var folderId = $('#docTree').find('.' + cafm.res.consts.CssClass_TreeViewSelected).data('key');

                // set the document upload folder
                cafm.docs.funcs.setUploadDocumentFolder(folderId);

                // hide the doc folder selection element
                $('#selectDocFolderPlc').hide();

                // hide the doc folder selection toolbar
                $('#docTreeTb').hideImp();

                // show the upload form
                $('#uploadNewDocsPlc').show();

                // show the doc upload form toolbar
                $('#docUploadTb').showImp();
            },
            cancel: function () {
                /// <summary>Document folder tree toolbar cancel button handler</summary>

                cafm.toolbar.standardActionToolbar.cancel();
            }
        }
    },
    dc: {
        /// <summary>Document controller container object</summary>
        
        init: function () {
            /// <summary>Init document controller handler</summary>

            cafm.panel.setContentHeightToFull();

            var dcFrame = $('#dcFrame');
            dcFrame.attr('src', cafm.url.get('Task/Shared/LoadingPage'));

            setTimeout(function () {

                $('#dcLoginForm').submit();
            }, 1000);
        }
    }
}